import React from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';

// Own constants/actions/components
import HomePage from 'pages/home';
import DetailExpPage from 'pages/detail-experiences';
import ExperienceRevivePage from 'pages/experience-revive-page';
import DetailExpRevivePage from 'pages/detail-experiences-revive';
import ShoppingCart from 'pages/shopping-cart';
import ShoppingCartPayment from 'pages/shopping-cart/payment';
import ShoppingCartConfirmation from 'pages/shopping-cart/confirmation';
import ShoppingCartError from 'pages/shopping-cart/error';
import ShoppingCartInsufficientPoints from 'pages/shopping-cart/insufficient-points';
import NotFoundPage from 'pages/404';

const Router = () => (
  <HashRouter>
    <Switch>
      <Redirect from="/" to="/home" exact />
      <Route exact path="/home">
        <HomePage />
      </Route>
      <Route exact path="/revive-experiencias">
        <ExperienceRevivePage />
      </Route>
      <Route exact path="/mis-experiencias">
        <ShoppingCart />
      </Route>
      <Route exact path="/experiencias-payment">
        <ShoppingCartPayment />
      </Route>
      <Route exact path="/experiencias-confirmacion">
        <ShoppingCartConfirmation />
      </Route>
      <Route exact path="/experiencias-error">
        <ShoppingCartError />
      </Route>
      <Route exact path="/insufficient-points">
        <ShoppingCartInsufficientPoints />
      </Route>
      <Route exact path="/:pathName/:id" component={DetailExpPage} />
      <Route exact path="/revive-experiencias/:pathName/:id" component={DetailExpRevivePage} />
      <Route component={NotFoundPage} />
    </Switch>
  </HashRouter>
);

export default Router;
